<script>
export default {
    name: 'IconArrowTop',
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="base-icon icon-arrow-top" viewBox="0 0 64 64"><g clip-path="url(#a)"><path fill="currentColor"  fill-rule="evenodd" d="M0 31.96 31.867 0l.132.133.133-.133L64 31.96l-5.624 5.64-22.4-22.464V64h-7.952l-.001-48.864-22.4 22.465L0 31.96Z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h64v64H0z"/></clipPath></defs></svg>
</template>
